import script from "./UserManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserManager.vue?vue&type=script&setup=true&lang=ts"

import "./UserManager.vue?vue&type=style&index=0&id=0054cba3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0054cba3"]])

export default __exports__